/* popup-surface.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16qs130s%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1bhr%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m91wug%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo1wug%7Boverflow-x%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rkofajl%7Bborder-radius%3Avar(--ds-radius-small%2C3px)%7D");
import React from 'react';
import { type TPopupSurfaceProps } from './types';
const styles = {
  root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _16qs130s"
};

/**
 * Optional styled wrapper for popup content.
 *
 * Adds default visual styling (background, border-radius, box-shadow)
 * using design tokens. Consumers who want fully custom styling
 * should use `Popup.Content` without wrapping in `PopupSurface`.
 *
 * Exposed as `Popup.Surface` on the compound component.
 */
export function PopupSurface({
  children
}: TPopupSurfaceProps): React.ReactElement {
  return <div className={ax([styles.root])}>{children}</div>;
}